
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDuty as ObiDutyElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-duty.js';
 
 
 

 
 export const ObiDuty = createComponent({
   react: React,
   tagName: 'obi-duty',
   elementClass: ObiDutyElement,
   events: {
     
   }
  });
 
 